import {injectIntl} from 'react-intl';
import {createElement, PropTypes} from 'rlink-react';

import DocumentComponent from 'rlink-react-document/DocumentComponent.jsx';

class DocumentTitle extends DocumentComponent {
  get documentSlot () {
    return 'head';
  }

  get tagName () {
    return 'title';
  }
  get keyAttributeNames () {
    return [];
  }

  get innerText () {
    let title = this.formatMessage(this.props.title);
    let site = this.formatMessage(this.props.site);

    if (site !== '' && title !== '') {
      return `${title} - ${site}`;
    } else if (site !== '') {
      return site;
    } else {
      return title;
    }
  }
}

DocumentTitle.defaultProps = {
  site: '',
};

DocumentTitle.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.shape({
      id: PropTypes.string,
      defaultMessage: PropTypes.destring,
      description: PropTypes.string,
    }),
  ]).isRequired,
  site: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.shape({
      id: PropTypes.string,
      defaultMessage: PropTypes.destring,
      description: PropTypes.string,
    }),
  ]),
};


export default injectIntl(DocumentTitle);



// WEBPACK FOOTER //
// ./lib/rlink-react-document/DocumentTitle.jsx